export default {
    '0': {
        typeNum: 0,
        type: true,
        typeName: '启用',
    },
    '1': {
        typeNum: 1,
        type: false,
        typeName: '停用',
    },
};
